import * as React from 'react'
// views
import { RiskLink } from './views'

export const getRiskUrl = (riskId: string, riskTemplateId: string) => `/forms/edit/${riskId}/template/${riskTemplateId}`

interface OpenRiskLinkProps {
  riskId: string
  riskTemplateId: string
  children: React.ReactNode
}

/** Opens the linked form record in a new tab */

export const OpenRiskLink: React.FC<OpenRiskLinkProps> = ({ riskId, riskTemplateId, children }) => {
  // keeps react-select from opening the menu
  const onMouseDown = (e: React.MouseEvent) => e.stopPropagation()

  return (
    <RiskLink
      to={getRiskUrl(riskId, riskTemplateId)}
      target='_blank'
      rel='noopener noreferrer'
      onMouseDown={onMouseDown}>
      {children}
    </RiskLink>
  )
}
